import _ from 'lodash';
import { actions } from '../actions';

export const metricsReducer = (state = [], action) => {
  switch (action.type) {
    case actions.GET_METRICS_SUCCEED:
      if (!action.payload) {
        return [];
      }

      if (action.options.stateMapper) {
        return [...action.options.stateMapper(state), ...action.payload];
      }

      return [...action.payload];
    case actions.GET_METRICS_FAILURE:
      return [
        ...(_.get(action, 'options.stateMapper')
          ? action.options.stateMapper(state)
          : [])
      ];
    default:
      return state;
  }
};
